var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"rounded",class:{
			'v-btn--active': _vm.editor.isFocused && _vm.editor.isActive('bulletList')
		},attrs:{"color":_vm.editor.isFocused && _vm.editor.isActive('bulletList') ? 'primary' : 'transparent',"depressed":"","fab":"","small":""},on:{"click":function($event){_vm.editor.chain().focus().toggleBulletList().run()},"mousedown":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('v-icon',[_vm._v("\n\t\tmdi-format-list-bulleted\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }